import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import { useState } from "react";
import styles from "./HistoryDetails.module.scss";
import { HistoryCatalogItemTable } from "./catalogItems/utils/historyCatalogItemDetailsRows";
import { createDefaultHistoryCatalogItemDetailsView } from "./catalogItems/views/defaultHistoryCatalogItemDetailsView";
import { historyCatalogItemDetailsViewConfig } from "./catalogItems/views/historyCatalogItemDetailsViewConfig";

interface HistoryCatalogItemDetailsProps {
    table: HistoryCatalogItemTable;
    footer: React.ReactNode;
}

export const HistoryCatalogItemDetails: React.FC<
    HistoryCatalogItemDetailsProps
> = ({ table, footer }) => {
    const [view, setView] = useState<View>(() =>
        createDefaultHistoryCatalogItemDetailsView(table.kind),
    );

    return (
        <ViewTable
            data={table.rows}
            view={view}
            config={historyCatalogItemDetailsViewConfig}
            onViewChange={setView}
            emptyView={() => (
                <EmptyState header="No catalog item changes found" />
            )}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
